export const isBottomReached = (listboxNode: HTMLElement) =>
  // We need to round here because on some browsers the scrollTop value is a float.
  // On large zoom levels, it might be even necessary to create a treshold or use a different approach.
  listboxNode.scrollTop + listboxNode.clientHeight + 1 >=
  listboxNode.scrollHeight;
